import React from "react";
import {Typography} from "@mui/material";
import View from "../../components/View"
import Headline from "../../components/Headline";
import Page from "../../components/Page";

const About = () => {
    return (
        <Page>
            <View>
                <Headline text="About the application"/>
                <Typography mt={2} align={"left"}>
                    This application is a replacement for a ten year old app that I built for our dive club.
                </Typography>
                <Typography mt={2} align={"left"}>
                    I love hearing from you and suggestions on how this app can be improved.
                </Typography>
            </View>
            <View>
                <Headline text="About me"/>
                <Typography mt={2} align={"left"}>
                    My name is Patrik Falk and I am CMAS *** Instructor, Technical- and Rebreather diver.
                </Typography>
                <Typography mt={2} align={"left"}>
                    I live in south of Sweden where I teach, dive and work.
                </Typography>
                <Typography mt={2} align={"left"}>
                    When I am not diving I work as a software developer.
                </Typography>
            </View>
            <View>
                <Headline text="A big thanks"/>
                <Typography mt={2} align={"left"}>
                    Dirk Lehmann (Germany) for input, testing and support.
                </Typography>
                <Typography mt={2} align={"left"}>
                    Dirks is a VDST/CMAS-Instructor (**, Apnea, Nitrox, Handicapped-Diver)
                </Typography>
            </View>
            <View>
                <Headline text="Warning"/>
                <Typography mt={2} align={"left"}>
                    This application is not a substitute for proper training and should not be used as a
                    substitute for proper dive planning or the primary blending and planning methods
                    taught during training.
                </Typography>
                <Typography mt={2} align={"left"}>
                    Please do not attempt to handle high pressure oxygen or fill SCUBA cylinders without
                    proper
                    training.
                </Typography>
                <Typography mt={2} align={"left"}>
                    Training for Nitrox blending is available from various SCUBA Diving training agencies
                    including CMAS, PADI, SSI, TDI/SDI, NAUI, GUE and others.
                </Typography>
            </View>
        </Page>
    );
}

export default About;